// Maps ISO 3166-1 alpha-3 country codes to a default IANA timezone (continent/city).
// For countries spanning multiple timezones, the capital city's timezone is used.
const COUNTRY_CODE3_TO_TIMEZONE: Record<string, string> = {
  ABW: 'America/Aruba',
  AFG: 'Asia/Kabul',
  AGO: 'Africa/Luanda',
  AIA: 'America/Anguilla',
  ALB: 'Europe/Tirane',
  AND: 'Europe/Andorra',
  ANT: 'America/Curacao',
  ARE: 'Asia/Dubai',
  ARG: 'America/Argentina/Buenos_Aires',
  ARM: 'Asia/Yerevan',
  ASM: 'Pacific/Pago_Pago',
  ATA: 'Antarctica/Casey',
  ATF: 'Indian/Kerguelen',
  ATG: 'America/Antigua',
  AUS: 'Australia/Sydney',
  AUT: 'Europe/Vienna',
  AZE: 'Asia/Baku',
  BDI: 'Africa/Bujumbura',
  BEL: 'Europe/Brussels',
  BEN: 'Africa/Porto-Novo',
  BFA: 'Africa/Ouagadougou',
  BGD: 'Asia/Dhaka',
  BGR: 'Europe/Sofia',
  BHR: 'Asia/Bahrain',
  BHS: 'America/Nassau',
  BIH: 'Europe/Sarajevo',
  BLR: 'Europe/Minsk',
  BLZ: 'America/Belize',
  BMU: 'Atlantic/Bermuda',
  BOL: 'America/La_Paz',
  BRA: 'America/Sao_Paulo',
  BRB: 'America/Barbados',
  BRN: 'Asia/Brunei',
  BTN: 'Asia/Thimphu',
  BVT: 'UTC',
  BWA: 'Africa/Gaborone',
  CAF: 'Africa/Bangui',
  CAN: 'America/Toronto',
  CCK: 'Indian/Cocos',
  CHE: 'Europe/Zurich',
  CHL: 'America/Santiago',
  CHN: 'Asia/Shanghai',
  CIV: 'Africa/Abidjan',
  CMR: 'Africa/Douala',
  COD: 'Africa/Kinshasa',
  COG: 'Africa/Brazzaville',
  COK: 'Pacific/Rarotonga',
  COL: 'America/Bogota',
  COM: 'Indian/Comoro',
  CPV: 'Atlantic/Cape_Verde',
  CRI: 'America/Costa_Rica',
  CUB: 'America/Havana',
  CXR: 'Indian/Christmas',
  CYM: 'America/Cayman',
  CYP: 'Asia/Nicosia',
  CZE: 'Europe/Prague',
  DEU: 'Europe/Berlin',
  DJI: 'Africa/Djibouti',
  DMA: 'America/Dominica',
  DNK: 'Europe/Copenhagen',
  DOM: 'America/Santo_Domingo',
  DZA: 'Africa/Algiers',
  ECU: 'America/Guayaquil',
  EGY: 'Africa/Cairo',
  ERI: 'Africa/Asmara',
  ESH: 'Africa/El_Aaiun',
  ESP: 'Europe/Madrid',
  EST: 'Europe/Tallinn',
  ETH: 'Africa/Addis_Ababa',
  FIN: 'Europe/Helsinki',
  FJI: 'Pacific/Fiji',
  FLK: 'Atlantic/Stanley',
  FRA: 'Europe/Paris',
  FRO: 'Atlantic/Faroe',
  FSM: 'Pacific/Pohnpei',
  GAB: 'Africa/Libreville',
  GBR: 'Europe/London',
  GEO: 'Asia/Tbilisi',
  GGY: 'Europe/Guernsey',
  GHA: 'Africa/Accra',
  GIB: 'Europe/Gibraltar',
  GIN: 'Africa/Conakry',
  GLP: 'America/Guadeloupe',
  GMB: 'Africa/Banjul',
  GNB: 'Africa/Bissau',
  GNQ: 'Africa/Malabo',
  GRC: 'Europe/Athens',
  GRD: 'America/Grenada',
  GRL: 'America/Nuuk',
  GTM: 'America/Guatemala',
  GUF: 'America/Cayenne',
  GUM: 'Pacific/Guam',
  GUY: 'America/Guyana',
  HKG: 'Asia/Hong_Kong',
  HMD: 'UTC',
  HND: 'America/Tegucigalpa',
  HRV: 'Europe/Zagreb',
  HTI: 'America/Port-au-Prince',
  HUN: 'Europe/Budapest',
  IDN: 'Asia/Jakarta',
  IMN: 'Europe/Isle_of_Man',
  IND: 'Asia/Kolkata',
  IOT: 'Indian/Chagos',
  IRL: 'Europe/Dublin',
  IRN: 'Asia/Tehran',
  IRQ: 'Asia/Baghdad',
  ISL: 'Atlantic/Reykjavik',
  ISR: 'Asia/Jerusalem',
  ITA: 'Europe/Rome',
  JAM: 'America/Jamaica',
  JEY: 'Europe/Jersey',
  JOR: 'Asia/Amman',
  JPN: 'Asia/Tokyo',
  KAZ: 'Asia/Almaty',
  KEN: 'Africa/Nairobi',
  KGZ: 'Asia/Bishkek',
  KHM: 'Asia/Phnom_Penh',
  KIR: 'Pacific/Tarawa',
  KNA: 'America/St_Kitts',
  KOR: 'Asia/Seoul',
  KWT: 'Asia/Kuwait',
  LAO: 'Asia/Vientiane',
  LBN: 'Asia/Beirut',
  LBR: 'Africa/Monrovia',
  LBY: 'Africa/Tripoli',
  LCA: 'America/St_Lucia',
  LIE: 'Europe/Vaduz',
  LKA: 'Asia/Colombo',
  LSO: 'Africa/Maseru',
  LTU: 'Europe/Vilnius',
  LUX: 'Europe/Luxembourg',
  LVA: 'Europe/Riga',
  MAC: 'Asia/Macau',
  MAR: 'Africa/Casablanca',
  MCO: 'Europe/Monaco',
  MDA: 'Europe/Chisinau',
  MDG: 'Indian/Antananarivo',
  MDV: 'Indian/Maldives',
  MEX: 'America/Mexico_City',
  MHL: 'Pacific/Majuro',
  MKD: 'Europe/Skopje',
  MLI: 'Africa/Bamako',
  MLT: 'Europe/Malta',
  MMR: 'Asia/Yangon',
  MNE: 'Europe/Podgorica',
  MNG: 'Asia/Ulaanbaatar',
  MNP: 'Pacific/Saipan',
  MOZ: 'Africa/Maputo',
  MRT: 'Africa/Nouakchott',
  MSR: 'America/Montserrat',
  MTQ: 'America/Martinique',
  MUS: 'Indian/Mauritius',
  MWI: 'Africa/Blantyre',
  MYS: 'Asia/Kuala_Lumpur',
  MYT: 'Indian/Mayotte',
  NAM: 'Africa/Windhoek',
  NCL: 'Pacific/Noumea',
  NER: 'Africa/Niamey',
  NFK: 'Pacific/Norfolk',
  NGA: 'Africa/Lagos',
  NIC: 'America/Managua',
  NIU: 'Pacific/Niue',
  NLD: 'Europe/Amsterdam',
  NOR: 'Europe/Oslo',
  NPL: 'Asia/Kathmandu',
  NRU: 'Pacific/Nauru',
  NZL: 'Pacific/Auckland',
  OMN: 'Asia/Muscat',
  PAK: 'Asia/Karachi',
  PAN: 'America/Panama',
  PCN: 'Pacific/Pitcairn',
  PER: 'America/Lima',
  PHL: 'Asia/Manila',
  PLW: 'Pacific/Palau',
  PNG: 'Pacific/Port_Moresby',
  POL: 'Europe/Warsaw',
  PRI: 'America/Puerto_Rico',
  PRK: 'Asia/Pyongyang',
  PRT: 'Europe/Lisbon',
  PRY: 'America/Asuncion',
  PSE: 'Asia/Hebron',
  PYF: 'Pacific/Tahiti',
  QAT: 'Asia/Qatar',
  REU: 'Indian/Reunion',
  ROU: 'Europe/Bucharest',
  RUS: 'Europe/Moscow',
  RWA: 'Africa/Kigali',
  SAU: 'Asia/Riyadh',
  SDN: 'Africa/Khartoum',
  SEN: 'Africa/Dakar',
  SGP: 'Asia/Singapore',
  SGS: 'Atlantic/South_Georgia',
  SHN: 'Atlantic/St_Helena',
  SJM: 'Arctic/Longyearbyen',
  SLB: 'Pacific/Guadalcanal',
  SLE: 'Africa/Freetown',
  SLV: 'America/El_Salvador',
  SMR: 'Europe/San_Marino',
  SOM: 'Africa/Mogadishu',
  SPM: 'America/Miquelon',
  SRB: 'Europe/Belgrade',
  SSD: 'Africa/Juba',
  STP: 'Africa/Sao_Tome',
  SUR: 'America/Paramaribo',
  SVK: 'Europe/Bratislava',
  SVN: 'Europe/Ljubljana',
  SWE: 'Europe/Stockholm',
  SWZ: 'Africa/Mbabane',
  SYC: 'Indian/Mahe',
  SYR: 'Asia/Damascus',
  TCA: 'America/Grand_Turk',
  TCD: 'Africa/Ndjamena',
  TGO: 'Africa/Lome',
  THA: 'Asia/Bangkok',
  TJK: 'Asia/Dushanbe',
  TKL: 'Pacific/Fakaofo',
  TKM: 'Asia/Ashgabat',
  TLS: 'Asia/Dili',
  TON: 'Pacific/Tongatapu',
  TTO: 'America/Port_of_Spain',
  TUN: 'Africa/Tunis',
  TUR: 'Europe/Istanbul',
  TUV: 'Pacific/Funafuti',
  TWN: 'Asia/Taipei',
  TZA: 'Africa/Dar_es_Salaam',
  UGA: 'Africa/Kampala',
  UKR: 'Europe/Kyiv',
  UMI: 'Pacific/Wake',
  URY: 'America/Montevideo',
  USA: 'America/New_York',
  UZB: 'Asia/Tashkent',
  VAT: 'Europe/Vatican',
  VCT: 'America/St_Vincent',
  VEN: 'America/Caracas',
  VGB: 'America/Tortola',
  VIR: 'America/St_Thomas',
  VNM: 'Asia/Ho_Chi_Minh',
  VUT: 'Pacific/Efate',
  WLF: 'Pacific/Wallis',
  WSM: 'Pacific/Apia',
  YEM: 'Asia/Aden',
  ZAF: 'Africa/Johannesburg',
  ZMB: 'Africa/Lusaka',
  ZWE: 'Africa/Harare',
};

export const getTimezoneForCountryCode3 = (countryCode3: string | null | undefined): string | undefined => {
  if (!countryCode3) return undefined;
  return COUNTRY_CODE3_TO_TIMEZONE[countryCode3.toUpperCase()];
};
